import { createSelector } from 'reselect'

import onboardingGuideCardSelector from '../onboarding_guide_card_selector'
import onboardingGuideCardStatusTypes from 'helpers/enums/onboardingGuideCardStatusTypes'
import onboardingGuideCardTypes from 'helpers/enums/onboardingGuideCardTypes'
import lessonStatusTypes from 'helpers/enums/lessonStatusTypes'

const hasLessonPublishedSelector = state => state.myLibrary.lessons &&
	!!state.myLibrary.lessons.find(
		lessonUid => state.lessons[lessonUid].data.published === lessonStatusTypes.PUBLISHED
	)

const cardSelector = onboardingGuideCardSelector(onboardingGuideCardTypes.LAUNCH_TOUR)

const onboardingGuideLaunchTourSelector = createSelector(
	[hasLessonPublishedSelector, cardSelector],
	(hasLessonPublished, cardData) => ({
		status: hasLessonPublished
			? cardData.status || onboardingGuideCardStatusTypes.PENDING
			: onboardingGuideCardStatusTypes.DISABLED,
	})
)

export default onboardingGuideLaunchTourSelector
